import React, { useMemo } from 'react';
import styles from './Overview.module.scss';
import { useUIGameEndContext } from '../../../../../contexts/UIGameEndContext.tsx';
import { StatsTable } from '../../StatsTable/index.ts';
import { VictoryPointDataController, VictoryPointStateReader } from '@colonist/game-base-types';
import { VICTORY_POINT_END_GAME_TIP, VICTORY_POINT_IMAGES } from '@colonist/ui-game';
import StatMMRChange from '@static/images/stat_mmr_change.svg';
import { useGameStore } from '../../../../../store/GameStoreContext.ts';
export const Overview = ()=>{
    const { playersByRank, userRankedStatesByColor } = useUIGameEndContext();
    const isRanked = useGameStore((state)=>state.gameDetails.isRanked);
    const goToLeaderboard = useGameStore((state)=>state.gameClientConfig.goToLeaderboard);
    const allKeys = useMemo(()=>Array.from(new Set(playersByRank.flatMap((player)=>Object.keys(player.victoryPoints).map((key)=>Number(key))))).sort(), [
        playersByRank
    ]);
    const headers = useMemo(()=>{
        const items = [];
        allKeys.forEach((key)=>{
            const victoryPointData = VictoryPointDataController.getVictoryPointByType(Number(key));
            if (victoryPointData) {
                items.push({
                    imagePath: VICTORY_POINT_IMAGES[victoryPointData.victoryPointType],
                    tooltip: {
                        key: VICTORY_POINT_END_GAME_TIP[victoryPointData.victoryPointType]
                    }
                });
            }
        });
        if (isRanked) {
            items.push({
                imagePath: StatMMRChange,
                tooltip: {
                    key: 'strings:game.endGame.overview.mmrChange'
                },
                onClick: goToLeaderboard
            });
        }
        return items;
    }, [
        allKeys
    ]);
    const rows = useMemo(()=>playersByRank.map((player)=>{
            const row = [];
            allKeys.forEach((key)=>{
                const calculatedPoint = VictoryPointStateReader.totalVictoryPointsOfType(player.victoryPoints, [
                    Number(key)
                ]);
                row.push(calculatedPoint || 0);
            });
            if (isRanked) {
                const userRankedState = userRankedStatesByColor[player.color];
                const mmrChange = userRankedState === null || userRankedState === void 0 ? void 0 : userRankedState.getEndGameData().amount;
                const numericalMMRChange = parseFloat(`${mmrChange}`);
                if (numericalMMRChange) {
                    row.push(numericalMMRChange);
                } else {
                    row.push(0);
                }
            }
            return row;
        }), [
        playersByRank,
        allKeys
    ]);
    const rowProps = isRanked ? {
        [rows[0].length - 1]: {
            rowRenderer: (row)=>{
                const rowValue = row > 0 ? `+${row}` : row < 0 ? row : '-';
                const rowClassName = row > 0 ? styles.textGreen : row < 0 ? styles.textRed : '';
                return /*#__PURE__*/ React.createElement("span", {
                    className: rowClassName
                }, rowValue);
            },
            disableRowHighlight: true
        }
    } : {};
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(StatsTable, {
        enableHighlight: true,
        headers: headers,
        rowProps: rowProps,
        rows: rows
    }));
};
